module.exports = __webpack_public_path__ + "1d4cecad80f90886fbadb0b956727c0e.png";